import styled from "styled-components";

/* Same intro card as the tracking integrations (/settings/facebook-pixel...) */
export const Container = styled.div<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 20px;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  .top {
    display: flex;
    gap: 1rem;
    align-items: center;
  }

  .text {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .status {
    display: inline-flex;
    gap: 0.375rem;
    align-items: center;
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1rem;
    color: ${props => (props.$active ? "var(--color-feedback-success)" : "var(--color-neutral-150)")};

    &::before {
      width: 6px;
      height: 6px;
      content: "";
      background-color: currentColor;
      border-radius: 100%;
    }
  }

  p {
    font-size: 0.8125rem;
    line-height: 1.25rem;
    color: var(--color-neutral-150);
  }
`;

type LogoContainerProps = {
  color: string;
};

export const LogoContainer = styled.div<LogoContainerProps>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: ${props => props.color};
  border-radius: 12px;

  svg {
    max-width: 26px;
    max-height: 26px;
  }
`;
